'use client';

import { Chart as ChartJS, Filler, Legend, LineElement, PointElement, RadialLinearScale, Tooltip } from 'chart.js';
import { FC } from 'react';
import { Radar } from 'react-chartjs-2';
import cn from '../Utils/cn';

ChartJS.register(RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

const characteristicsNames = ['proactivity', 'organization', 'adaptability', 'teamwork', 'stability'];

const radarOptions = {
	elements: {
		line: {
			borderWidth: 3,
		},
	},
	plugins: {
		legend: {
			display: false,
		},
	},
	scales: {
		r: {
			pointLabels: {
				color: 'rgb(44,30,91)',
				font: {
					size: 18,
					weight: 'bold',
				},
			},
			angleLines: {
				color: 'rgba(44,30,91,0.3)',
			},
			grid: {
				circular: true,
				color: ['rgba(44,30,91,0.3)', 'rgba(44,30,91,0.3)', 'rgba(44,30,91,0.3)', 'rgba(44,30,91,0.3)', 'rgba(44,30,91,1)'],
				borderColor: 'rgb(44,30,91)',
			},
			ticks: {
				color: 'rgb(44,30,91)',
			},
			suggestedMin: 0,
			suggestedMax: 100,
		},
	},
};

type Params = {
	candidate: any;
	className?: string;
};

const RadarChart: FC<Params> = ({ candidate, className }) => {
	if (candidate == null || characteristicsNames.some(label => typeof candidate[label] !== 'number')) {
		return null;
	}

	if (Object.keys(candidate || {}).length < 1) {
		return null;
	}

	return (
		<div className={cn('my-6 mx-auto max-w-md', className)}>
			<Radar
				options={radarOptions}
				data={{
					labels: ['A', 'B', 'C', 'D', 'E'],
					datasets: [
						{
							label: 'Resultado do candidato',
							data: characteristicsNames.map(label => candidate[label]),
							fill: true,
							backgroundColor: 'rgba(255, 144, 25, 0.25)',
							borderColor: 'rgb(255, 144, 25)',
							pointBackgroundColor: 'rgb(255, 144, 25)',
							pointBorderColor: '#fff',
							pointHoverBackgroundColor: '#fff',
							pointHoverBorderColor: 'rgb(255, 144, 25)',
						},
					],
				}}
			/>
		</div>
	);
};

export default RadarChart;
